

































import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import StarRating from 'vue-star-rating';

@Component({
    components: {
        StarRating,
    },
})
export default class Feedback extends Vue {
    public rating: number = 2.5;

    constructor() {
        super();
    }

    get hasRating(): boolean {
        return this.$store.getters['Feedback/hasRating'];
    }

    get hasComment(): boolean {
        return this.$store.getters['Feedback/hasComment'];
    }

    get comment(): string {
        return this.$store.getters['Feedback/comment'];
    }

    set comment(value: string) {
        this.$store.commit(Mutations.SET_FEEDBACK_COMMENT, value);
        return;
    }

    public submitFeedback() {
        this.$store.dispatch(Actions.SEND_FEEDBACK);
    }

    public dismissDialog() {
        this.$store.commit(Mutations.HIDE_FEEDBACK_DIALOG);
    }
}
